package com.patronat.top.ui.models

data class SelectOption(
    val id: String,
    val label: String
)
